import tinycolor from 'tinycolor2';

const SECONDARY_SHADE_KEYS = ['50', '100', '200', '300', '400', 'default', '500', '600', '700', '800'];

let storedPrimary: string | null = null;
let storedSecondary: string | null = null;

export const generateShades = (baseColor: string): Record<string, string> => ({
  '50': tinycolor(baseColor).lighten(40).toString(),
  '100': tinycolor(baseColor).lighten(30).toString(),
  '200': tinycolor(baseColor).lighten(20).toString(),
  '300': tinycolor(baseColor).lighten(10).toString(),
  default: baseColor,
  '500': tinycolor(baseColor).darken(10).toString(),
  '600': tinycolor(baseColor).darken(20).toString(),
  '700': tinycolor(baseColor).darken(30).toString(),
  '800': tinycolor(baseColor).darken(40).toString(),
});

const writeShades = (colorVariable: string, shades: Record<string, string>) => {
  const rootStyle = document.documentElement.style;
  for (const [key, value] of Object.entries(shades)) {
    rootStyle.setProperty(`--color-${colorVariable}-${key}`, value);
  }
};

const clearSecondaryInlineVars = () => {
  const rootStyle = document.documentElement.style;
  SECONDARY_SHADE_KEYS.forEach((key) => {
    rootStyle.removeProperty(`--color-secondary-${key}`);
  });
};

export const applyColorTheme = (color: string, colorVariable: 'primary' | 'secondary') => {
  if (colorVariable === 'primary') {
    storedPrimary = color;
  } else {
    storedSecondary = color;
  }
  applyStoredBrandColors();
};

export const applyStoredBrandColors = () => {
  const isDark = document.documentElement.classList.contains('dark');
  if (storedPrimary) {
    writeShades('primary', generateShades(storedPrimary));
  }
  if (isDark) {
    clearSecondaryInlineVars();
    return;
  }
  if (storedSecondary) {
    writeShades('secondary', generateShades(storedSecondary));
  }
};
